import {fetchQuery} from 'relay-runtime';
import environment from '../../../RelayEnvironment';
import {useState} from 'react';

export const useForecastFetchQuery = query => {
	const [data, setData] = useState(null);

	const fetch = (variables = {}, onSuccess = () => false) => {
		fetchQuery(environment.getInstance(), query, variables).then(
			data => {
				setData(data);
				onSuccess();
			},
			// Error handling here!!!
			_ => {}
		);
	};

	return {fetch, data};
};
